import React, { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import './full-yarn-count-list.scss';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import YarnCountService from '../../services/yarn-count.service';
import YarnQualityService from '../../services/yarn-quality.service';
import YarnTypeService from '../../services/yarn-type.service';
import HSCodeService from '../../services/hsCode.service';
import FullYarnCountService from '../../services/full-yarn-count.service';
import CheckDuplicate from '../check-duplicate/check-duplicate';

import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent, AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import yarnTypeService from '../../services/yarn-type.service';
import fullYarnCountService from '../../services/full-yarn-count.service';
import SetupAdd from '../setup/setup-add';
import YarnCountList from '../yarn-count/yarn-count-list';
import YarnTypeList from '../yarn-type/yarn-type-list';
// import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment';
import SecurityService from "../security/security.service";


export default function FullYarnCountEdit(props) {

    const [yarnCounts, setYarnCounts] = useState([]);
    const [loadingYarnCount, setYarnCountLoading] = useState(false);
    const [yarnQualities, setYarnQualities] = useState([]);
    const [loadingYarnQuality, setYarnQualityLoading] = useState(false);
    const [yarnTypes, setYarnTypes] = useState([]);
    const [loadingYarnType, setYarnTypeLoading] = useState(false);
    const [hSCodes, setHSCodes] = useState([]);
    const [loadingHSCode, setHSCodeLoading] = useState(false);
    const [showAddNewDialog, setShowAddNewDialog] = useState(false);
    const [dialogType, setDialogType] = useState('');
    const yarnCountElem = useRef(null);

    const [yarnCount, setYarnCount] = useState(props.YarnCount);
    const [yarnCountID, setYarnCountID] = useState(props.YarnCountID);
    const [yarnThread, setYarnThread] = useState(props.YarnThread);
    const [hSCode, setHSCode] = useState(props.HSCodeNo);
    const [hSCodeID, setHSCodeID] = useState(props.HSCodeID);
    // const [yarnQuality, setYarnQuality] = useState();
    const [yarnQualityID, setYarnQualityID] = useState(props.YarnQualityID);
    const [yarnType, setYarnType] = useState(props.YarnType);
    const [yarnTypeID, setYarnTypeID] = useState(props.YarnTypeID);
    const [yarnQualityValue, setYarnQualityValue] = useState(props.YarnQuality);
    const [yarnCountValue, setYarnCountValue] = useState(props.YarnCount);
    const [yarnTypeValue, setYarnTypeValue] = useState(props.YarnType);

    const [checkDuplicate, setCheckDuplicate] = useState(false);
    const [checkDuplicateValue, setCheckDuplicateValue] = useState('');
    useEffect(() => {
    setTimeout(() => {
      
      // YarnCountID ,YarnThread ,YarnQualityID ,YarnTypeID
      console.log({
        YarnCount:yarnCountValue,
        YarnQuality:yarnQualityValue,
        YarnThread:yarnThread,
        YarnType:yarnTypeValue,
        checkDuplicate
      })
      if(yarnCountID != undefined && yarnThread != undefined && yarnQualityID != undefined && yarnTypeID != undefined && checkDuplicate == true){
        console.log(props.dataList)
        let array = props.dataList.filter(obj => obj.FullYarnCountID !== props.FullYarnCountID)
        let check = CheckDuplicate.withCombination(array,['YarnCount','YarnThread','YarnQuality','YarnType'],{
          YarnCount:yarnCountValue,
          YarnThread:yarnThread,
          YarnQuality:yarnQualityValue,
          YarnType:yarnTypeValue,
          
  
        })
        console.log(check)
        
        if(!check){
          document.querySelector('#fullYarnCountGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
          setCheckDuplicateValue('')
        }else{
          document.querySelector('#fullYarnCountGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
          setCheckDuplicateValue('Duplicate Value Detected!')
      }
     }
    }, 500);
    }, [yarnCountID,yarnThread,yarnQualityID,yarnTypeID ]);

    const useStyles = makeStyles((theme) => ({

        fromWrapper: {
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(8),
        },
    }));

    useEffect(() => {
    setTimeout(() => {
      setCheckDuplicate(true)
      document.querySelector('#fullYarnCountGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
     }, 500);

        getYarnCount();
        getYarnQuality();
        getYarnType();
        getHSCode();
    }, []);

    const getYarnCount = async () => {
        setYarnCountLoading(true);
        YarnCountService.getYarnCountsForYarnContract()
            .then((response) => {
                setYarnCounts(response.data.recordset);
                setYarnCountLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setYarnCountLoading(false);
            });
    };

    const getYarnQuality = async () => {
        setYarnQualityLoading(true);
        YarnQualityService.getYarnQualitiesForYarnContract()
            .then((response) => {
                setYarnQualities(response.data.recordset);
                setYarnQualityLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setYarnQualityLoading(false);
            });
    };

    const getYarnType = async () => {
        setYarnTypeLoading(true);
        yarnTypeService.getYarnTypesForYarnContract()
            .then((response) => {
                setYarnTypes(response.data.recordset);
                setYarnTypeLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setYarnTypeLoading(false);
            });
    };

    const getHSCode = async () => {
        setHSCodeLoading(true);
        HSCodeService.getYarnContractImportLC()
            .then((response) => {
                setHSCodes(response.data.recordset);
                setHSCodeLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setHSCodeLoading(false);
            });
    };


    const INITIAL_FORM_STATE = {
        YarnCountID: '',
        YarnThread: '',
        YarnQualityID: '',
        YarnTypeID: '',
        HSCodeID: '',
    };

    const FORM_VALIDATION = Yup.object().shape({
        YarnCountID: Yup.string().required('Required'),
        YarnThread: Yup.string().required('Required'),
        YarnQualityID: Yup.string().required('Required'),
        YarnTypeID: Yup.string().required('Required'),
        HSCodeID: Yup.string().required('Required'),
    });
  const [addNewClicked, setAddNewClicked] = useState(false);
    const yarnCountChange = (e) => {
    if(e?.e?.srcElement) {
      setYarnCountValue(e?.itemData?.value)
    }
    if(e?.e?.srcElement?.id) {
            console.log(e?.itemData?.id)
            setYarnCountID(e?.itemData?.id);
        }
    }

    const yarnQualityChange = (e) => {
        if(e?.e?.srcElement) {
        setYarnQualityValue(e?.itemData?.value)
    }
    if(e?.e?.srcElement?.id) {
      setYarnQualityID(e?.itemData?.id)
        }
    }

    const yarnTypeChange = (e) => {
    if(e?.e?.srcElement) {

        setYarnTypeValue(e?.itemData?.value)
    }
    if(e?.e?.srcElement?.id) {
            setYarnTypeID(e?.itemData?.id);
        }
    }

    const hSCodeChange = (e) => {
        if (e?.e?.srcElement) {
            setHSCode(e?.itemData?.value)
        }
        if (e?.e?.srcElement?.id) {
            setHSCodeID(e?.itemData?.id);
        }
    }

    const fields: object = { text: 'value', value: 'id' };
    const ddlFields: object = { value: 'value' };

    const classes = useStyles();

    const minDate: Date = new Date(moment().startOf('day'));

    const onAddNewClick = (type) => {
        console.log('type: ', type);
    if(type !== ''){
      setAddNewClicked(true)
            setShowAddNewDialog(false);
            setDialogType(type);
            setTimeout(() => {
                setShowAddNewDialog(true);
            }, 100)
        }
    };

    const header = () => {
        if (showAddNewDialog) {
            return <div>Add New {dialogType.match(/[A-Z]+[a-z]+/g).join(" ")} </div>;
        }
        else {
            return (<></>);
        }
    };

    const onClose = () => {
    setAddNewClicked(false)
        setShowAddNewDialog(false);
        switch (dialogType) {
            case 'YarnQuality':
                getYarnQuality();
                break;
            case 'YarnCount':
                getYarnCount();
                break;
            case 'YarnType':
                getYarnType();
                break;
            case 'HSCode':
                getHSCode();
                break;
            default:
                break;
        }
    }

    const footerTemplate = () => {
        if (showAddNewDialog) {
            return (<div>
                <button id="btnSave" className="e-control e-btn e-primary" data-ripple="true" onClick={onClose}>Close</button>
            </div>);
        }
        else {
            <h3 style={{ textAlign: 'center', width: '80%' }}>Conversion Purchase Contract - Add</h3>
            return (<></>);
        }
    };

    const contentTemplate = (props) => {
        console.log('props: ', props);
        if (showAddNewDialog) {
            console.log('dialog template');
            if (dialogType === 'YarnCount') {
                return (
                    <YarnCountList isDialog={true} />
                )
            } else if (dialogType === 'YarnType') {
                return (
                    <YarnTypeList isDialog={true} />
                )
            } else {
                return (
                    <div>
                        <SetupAdd type={dialogType} isDialog={true}
                        />
                        {/* <SetupAdd onChange={value => setWord(value)}*/}
                    </div>
                );
            }
        }
        else {
            return (
                <></>
            );
        }
    };

    const AddNewSecurity = (addNewType) => {
        var res =""
          switch(SecurityService.canUserAccess(`${addNewType}List`)){
          case true:
            //('true')
           return res = 'ADD NEW';
          default:
            break;
        } 
       return res
      }
      
  let yarnCountRef = useRef(null)
  let yarnQualityRef = useRef(null)
  let yarnTypeRef = useRef(null)
  let hsCodeRef = useRef(null)
    return (
        <div className='yarn-contract-container'>
      <div className='backgroundImg'></div>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <div className='heading'>
                        <h3 style={{ textAlign: 'center', width: '100%' }}>Full Yarn Count - Edit</h3>
                    </div>

                </Grid>
                <div className='App' id='dialog-target'>
                    <DialogComponent
                        width='800px'
                        visible={showAddNewDialog}
                        close={showAddNewDialog}
                        content={contentTemplate}
                        isModal={true}
                        header={header}
                        footerTemplate={footerTemplate}
                    />
                </div>
                <Grid item xs={12}>
                    <Container>
                        <div className={classes.fromWrapper}>
                            <Formik
                                initialValues={{
                                    ...INITIAL_FORM_STATE,
                                }}
                                validationSchema={FORM_VALIDATION}
                                onSubmit={async (values) => {
                                    console.log('form values: ', values);
                                    return new Promise((res) => {
                                        fullYarnCountService.create(values).then(
                                            (response) => {
                                                console.log('response: ', response);
                                            }
                                        );
                                        setTimeout(res, 2500);
                                    });
                                }}
                            >
                                {({ values, errors, isSubmitting }) => (
                                    <div>
                                        {/* <pre> {JSON.stringify({ values, errors }, null, 4)} </pre> */}
                                        <Grid container spacing={2}>

                                            <Grid item xs={12} >
                                                {loadingYarnCount ? (
                                                    <div>... Loading Yarn Count </div>
                                                ) : (
                                                    <div>
                                                        <AutoCompleteComponent
                                                            ref={yarnCountElem}
                                                            // created={() => yarnCountElem.current.inputElement.focus()}
                                                            id='YarnCount'
                                                            dataSource={yarnCounts}
                                                            fields={ddlFields}
                                                            placeholder='Select Yarn Count'
                                                            floatLabelType='Auto'
                                                            highlight={true}
                              created={()=>{
                                setTimeout(() => {
                                  yarnCountRef.current.element.focus()
                                }, 300);
                              }}
                              ref={yarnCountRef}
                                                            select={yarnCountChange}
                              change={yarnCountChange}
                              value={yarnCountValue}
                              blur={()=>{
                                console.log('dfdfblur',yarnCountID)
                                if (yarnCountID  == undefined  || yarnCountRef.current.value == null || yarnCountRef.current.value == '' || yarnCountID == undefined || yarnCountID == null) {
                                 if(yarnCountValue != ''){
                                   let resstr = yarnCounts.some(e=>e.value ==  yarnCountValue);
                                   console.log(resstr)
                                   if(resstr === false){
                                    //  setProductGroupErorr(`${yarnCountValue} Value Not Find ` )
                                     document.getElementById("YarnCount").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                      //  setProductItemTypeError('')
                                       document.getElementById("YarnCount").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
     
                                     }, 1000);
                                   }
                                 }
                                 if (addNewClicked == false){
                                  yarnCountRef.current.element.focus()
                              
                                 }
                               }
                             }}
                                                        />
                                                        <TextBoxComponent
                                                            type='hidden'
                                                            name='YarnCountID'
                                                            value={yarnCountID}
                                                        />
                            <span className='add-new' onClick={()=>onAddNewClick('YarnCount')}>
                            {AddNewSecurity('YarnCount')} 
                            </span>
                                                    </div>
                                                )}
                                            </Grid>

                                            <Grid item xs={4}>
                                                <TextBoxComponent
                                                    className='e-input'
                                                    type='number'
                                                    placeholder='Yarn Thread'
                                                    name='YarnThread'
                                                    floatLabelType='Auto'
                                                    value={yarnThread}
                          onChange={(e)=>{
                            setYarnThread(e.value)
                          }}
                                                />
                                            </Grid>


                                            <Grid item xs={4}>
                                                {loadingYarnQuality ? (
                                                    <div>... Loading Yarn Quality </div>
                                                ) : (
                                                    <div>
                                                        <AutoCompleteComponent
                                                            id='YarnQuality'
                                                            dataSource={yarnQualities}
                                                            fields={ddlFields}
                                                            placeholder='Select Yarn Quality'
                                                            floatLabelType='Auto'
                                                            highlight={true}
                                                            select={yarnQualityChange}
                                                            change={yarnQualityChange}
                                                            value={yarnQualityValue}
                                                            ref={yarnQualityRef}
                              blur={()=>{
                                console.log('dfdfblur',yarnCountID)
                                if (yarnQualityID  == undefined  || yarnQualityRef.current.value == null || yarnQualityRef.current.value == '' || yarnQualityID == undefined || yarnQualityID == null) {
                                 if(yarnQualityValue != ''){
                                   let resstr = yarnQualities.some(e=>e.value ==  yarnQualityValue);
                                   console.log(resstr)
                                   if(resstr === false){
                                    //  setProductGroupErorr(`${yarnQualityValue} Value Not Find ` )
                                     document.getElementById("YarnQuality").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                      //  setProductItemTypeError('')
                                       document.getElementById("YarnQuality").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
     
                                     }, 1000);
                                   }
                                 }
                                 if (addNewClicked == false){
                                  yarnQualityRef.current.element.focus()
                              
                                 }
                               }
                             }}
                                                        />
                                                        <TextBoxComponent
                                                            type='hidden'
                                                            name='YarnQualityID'
                                                            value={yarnQualityID}
                                                        />
                            <span className='add-new' onClick={()=>onAddNewClick('YarnQuality')}>
                                                        {AddNewSecurity('YarnQuality')} 
                                                        </span>
                                                    </div>
                                                )}
                                            </Grid>


                                            <Grid item xs={4}>
                                                {loadingYarnType ? (
                                                    <div>... Loading Yarn Type </div>
                                                ) : (
                                                    <div>
                                                        <AutoCompleteComponent
                                                            id='YarnType'
                                                            dataSource={yarnTypes}
                                                            fields={ddlFields}
                                                            placeholder='Select Yarn Type'
                                                            floatLabelType='Auto'
                                                            highlight={true}
                                                            select={yarnTypeChange}
                              change={yarnTypeChange}
                              // value={importLCID}
                              value={yarnTypeValue}
                              ref={yarnTypeRef}
                              blur={()=>{
                                console.log('dfdfblur',yarnCountID)
                                if (yarnTypeID  == undefined  || yarnTypeRef.current.value == null || yarnTypeRef.current.value == '' || yarnTypeID == undefined || yarnCountID == null) {
                                 if(yarnTypeValue != ''){
                                   let resstr = yarnTypes.some(e=>e.value ==  yarnTypeValue);
                                   console.log(resstr)
                                   if(resstr === false){
                                    //  setProductGroupErorr(`${yarnTypeValue} Value Not Find ` )
                                     document.getElementById("YarnType").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                      //  setProductItemTypeError('')
                                       document.getElementById("YarnType").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
     
                                     }, 1000);
                                   }
                                 }
                                 if (addNewClicked == false){
                                  yarnTypeRef.current.element.focus()
                              
                                 }
                               }
                             }}
                                                        />
                                                        <TextBoxComponent
                                                            type='hidden'
                                                            name='YarnTypeID'
                                                            value={yarnTypeID}
                                                        />
                            <span className='add-new' onClick={()=>onAddNewClick('YarnType')}>
                                                        {AddNewSecurity('YarnType')} 
                                                        </span>
                                                    </div>
                                                )}
                                            </Grid>


                                            <Grid item xs={4}>
                                                {loadingHSCode ? (
                                                    <div>... Loading HS Code </div>
                                                ) : (
                                                    <div>
                                                        <AutoCompleteComponent
                              id='HSCodeIDS'
                              dataSource={hSCodes}
                                                            fields={ddlFields}
                                                            placeholder='Select HS Code'
                                                            floatLabelType='Auto'
                              // cssClass='HSCodeIDS'
                              className='Hs'
                              
                                                            highlight={true}
                                                            select={hSCodeChange}
                                                            change={hSCodeChange}
                              ref={hsCodeRef}
                              value={hSCode}
                              blur={()=>{
                                console.log('dfdfblur',hSCodeID)
                                if (hSCodeID  == undefined  || hsCodeRef.current.value == null || hsCodeRef.current.value == '' || hSCodeID == undefined || hSCodeID == null) {
                                 if(hSCode != ''){
                                   let resstr = hSCodes.some(e=>e.value ==  hSCode);
                                   console.log(resstr)
                                   if(resstr === false){
                                    //  setProductGroupErorr(`${yarnTypeValue} Value Not Find ` )
                                     document.getElementById("HSCodeIDS").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                     setTimeout(() => {
                                      //  setProductItemTypeError('')
                                       document.getElementById("HSCodeIDS").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
     
                                     }, 1000);
                                   }
                                 }
                                 if (addNewClicked == false){
                                  hsCodeRef.current.element.focus()
                              
                                 }
                               }
                               if(checkDuplicateValue == '' && hSCodeID != undefined){
                                setTimeout(()=>document.querySelector('#fullYarnCountGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').focus(),600);
  
                              }
                             }}

                                                        />
                                                        <TextBoxComponent
                                                            type='hidden'
                                                            name='HSCodeID'
                                                            value={hSCodeID}
                                                        />
                            <span className='add-new' onClick={()=>onAddNewClick('HSCode')}>
                                                        {AddNewSecurity('HSCode')} 
                                                        </span>
                                                    </div>
                                                )}
                                            </Grid>

                                        </Grid>
                                    </div>
                                )}
                            </Formik>
                        </div>
                    </Container>
                </Grid>
            </Grid>
      <div className='sidebarPopup2' ></div>
      <h3 className="duplicate " style={checkDuplicateValue != '' ? {transform:'scale(1)'}:{}}>{checkDuplicateValue}</h3>

        </div>
    // </div>
    );
}
